var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('h2',[_vm._v("Default Content Hello")]),(_vm.myrooms)?_c('ul',_vm._l((_vm.myrooms),function(item){return _c('li',{key:item.uid},[_vm._v("\n      "+_vm._s(item.title)+"\n    ")])}),0):_vm._e(),_c('hr')])
}
var staticRenderFns = []

export { render, staticRenderFns }